import React, {useEffect, useState} from "react";
import API from 'libs/api';
import { useNavigate } from 'react-router-dom';
import ICON from 'components/cmp_icon/cmp_icon'
import TABLE from 'components/cmp_table/cmp_table'

import './crd_activities.css'



export default function CRD_ACTIVITIES({ var_status }) {

    //  variable declarations ------------------------------------------------------------------------------------------

    const navigate = useNavigate();

    //  data table variables
    const [ var_data, set_data ] = useState([]);
    const [ var_data_settings, set_data_settings ] = useState({
        limit: 15,
        offset: 0,
        totalrows: 0,
        search: '',
        sortby: 'lastmodified',
        sortorder: 'asc'
    });
    const [ var_totalrows, set_totalrows ] = useState(0);

    //  data ready variables
    const [ var_ready, set_ready ] = useState(false);
    const [ var_processing, set_processing ] = useState('inactive');



    //  event listeners ------------------------------------------------------------------------------------------------

    useEffect(() => {
        get_activities(var_data_settings);
    }, [])



    //  async functions ------------------------------------------------------------------------------------------------

    async function get_activities(data_settings) {

        set_ready(false);
        set_processing('processing');

        //  use current data settings if none are submitted
        data_settings && set_data_settings(data_settings);
        let settings = data_settings || var_data_settings;

        try {
            let results = await API_get_activities(settings);

            //  set totalrows
            set_totalrows(results.totalrows);

            //  set data
            set_data(results.results === undefined ? [] : results.results);

            set_processing('inactive');
            set_ready(true);
        } catch (e) {
            set_processing('error');
        }

    }



    //  API calls ------------------------------------------------------------------------------------------------------

    function API_get_activities(settings){
        let var_parameters = {queryStringParameters: settings};
        return API.get('admin-activities', '/get-activities', var_parameters);
        //return API.get('admin-providers', '/get-providers/PUBLISHED', var_parameters);
    }



    //  event functions ------------------------------------------------------------------------------------------------

    function onClick_activity(item){
        navigate('/activity/'+item.id);
    }

    function onChange_status(status){
        let new_filter = {...var_data_settings};
        new_filter.status = status
        set_data_settings(new_filter)
        get_activities(new_filter);
    }



    // RENDER CONTAINER ================================================================================================

    return (

        <div className='card activities'>
            <div className='card__header'>
                <div className='card__header__title_totalrows'>
                    <div className='text--md bold'>Activities</div>
                    <div className='card__header__totalrows text--md normal'>{var_totalrows.toLocaleString()}</div>
                </div>
            </div>
            <div className='card__content'>

                <TABLE
                    var_data_settings={var_data_settings}
                    set_data_settings={set_data_settings}
                    onChange={get_activities}
                    processing={var_processing}
                    totalrows={var_totalrows}
                >
                    <headers>
                        <header sortby='activity'>Activity</header>
                        <header sortby='category'>Cateogry</header>
                        <header sortby='lastmodified' width='192px'>Modified</header>
                        <header sortby='lastmodifiedby'>Modified by</header>
                    </headers>
                    <data>
                        {var_data.map(item =>
                            <row key={item.id} onClick={()=>onClick_activity(item)}>
                                <cell>{item.activity}</cell>
                                <cell>{item.category}</cell>
                                <cell>{item.lastmodified}</cell>
                                <cell>{item.lastmodifiedby}</cell>
                            </row>
                        )}
                    </data>
                </TABLE>

            </div>
        </div>

    )
}